/** Up to two initials for an avatar: the first letter of the first two words that
 *  start with a letter. "Alex Dawson" → "AD", "Rauf (Teller)" → "R"; else from `fallback`, else "?". */
export function initials(name: string, fallback = ''): string {
  return lettersOf(name) || lettersOf(fallback) || '?'
}

function lettersOf(text: string): string {
  const letters: string[] = []
  for (const word of text.trim().split(/\s+/)) {
    const first = /^\p{L}/u.exec(word)?.[0]
    if (first) letters.push(first)
    if (letters.length === 2) break
  }
  return letters.join('').toUpperCase()
}
